import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["id", "as", "className", "children", "href", "link", "callout", "checkbox", "button", "fixedHeight", "grouped", "placeholder", "ariaLabel", "radioSelected"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import find from 'lodash.find';
import CardHeader from './CardHeader';
import CardFooter from './CardFooter';
import Link from './Link';
import { uniqueIdForComponent } from '../util';
var propTypes = {
  /** id for the card */
  id: PropTypes.string,
  /** 
    overrides the DOM element or React component that should be rendered as the root element
  */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  /**
    children
  */
  children: PropTypes.node.isRequired,
  /**
    additional styling for the root element
  */
  className: PropTypes.string,
  /**
    the URL of the link card
  */
  href: PropTypes.string,
  /**
   * the node to be used as the link for the card
   */
  link: PropTypes.node,
  /**
   * button prop for card, changes card to a button, using both `button` AND `href` || `link` on the component is invalid
   */
  button: PropTypes.bool,
  /**
    set cards to have same height
  */
  fixedHeight: PropTypes.bool,
  /**
   * indicates if this card is grouped card inside of a panel
   */
  grouped: PropTypes.bool,
  /**
   * indicates the card displays a callout indicator
   */
  callout: PropTypes.bool,
  /**
   * indicates that there is a checkbox control in the header
   */
  checkbox: PropTypes.bool,
  /** specifies if the card is a placeholder card */
  placeholder: PropTypes.bool,
  /**
   * used by screen readers to describe the card
   */
  ariaLabel: PropTypes.string,
  /**
   * used to select card with a radio control
   */
  radioSelected: PropTypes.bool
};
var defaultProps = {
  id: undefined,
  as: 'article',
  className: undefined,
  href: undefined,
  link: undefined,
  checkbox: false,
  fixedHeight: false,
  grouped: false,
  ariaLabel: undefined,
  callout: false,
  button: false,
  placeholder: false,
  radioSelected: undefined
};
var Card = /*#__PURE__*/function (_React$Component) {
  _inherits(Card, _React$Component);
  var _super = _createSuper(Card);
  function Card(props) {
    var _this;
    _classCallCheck(this, Card);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      if (event.target.type === 'checkbox') {
        _this.setState(function (prevState) {
          return {
            selected: !prevState.selected
          };
        });
      }
    });
    _this.state = {
      selected: false
    };
    return _this;
  }
  _createClass(Card, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        Element = _this$props.as,
        className = _this$props.className,
        children = _this$props.children,
        href = _this$props.href,
        link = _this$props.link,
        callout = _this$props.callout,
        checkbox = _this$props.checkbox,
        button = _this$props.button,
        fixedHeight = _this$props.fixedHeight,
        grouped = _this$props.grouped,
        placeholder = _this$props.placeholder,
        ariaLabel = _this$props.ariaLabel,
        radioSelected = _this$props.radioSelected,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var titleId = id || uniqueIdForComponent();
      var cardChildren = React.Children.toArray(children);
      var cardFooter = null;
      var hasTitleElement = false;

      // take the footer out of the children,
      // it will be rendered outside of the fixed card container
      // and append the `wds-js-fix-height__child` class to other elements
      // link prop will be set for cards that link to other locations
      cardFooter = find(cardChildren, function (child) {
        return child && child.type && child.type.displayName === CardFooter.displayName;
      });
      if (href || link) {
        if (!placeholder) {
          if (cardFooter) {
            cardFooter = /*#__PURE__*/React.cloneElement(cardFooter, {
              link: true
            });
          } else {
            cardFooter = /*#__PURE__*/React.createElement(CardFooter, {
              link: true
            });
          }
        }
      }

      // propagate the callout, fixedHeight and titleId props on the CardHeader
      cardChildren = cardChildren.filter(function (child) {
        return child.type.displayName !== CardFooter.displayName;
      }).map(function (child) {
        if (child && child.type && child.type.displayName === CardHeader.displayName) {
          if (child.props.title) {
            hasTitleElement = true;
          }
          return /*#__PURE__*/React.cloneElement(child, {
            callout: callout,
            titleId: titleId,
            fixedHeight: fixedHeight
          });
        }
        if (fixedHeight) {
          return /*#__PURE__*/React.cloneElement(child, {
            fixedHeight: fixedHeight
          });
        }
        return child;
      });
      var cardBody = fixedHeight ? /*#__PURE__*/React.createElement("span", {
        className: "wds-c-card__height-container wds-js-fix-height"
      }, cardChildren) : cardChildren;
      var cardClass = classnames('wds-c-card', className, {
        'wds-c-card--with-checkbox': checkbox,
        'wds-c-card--fixed-height': fixedHeight,
        'wds-c-card--placeholder': placeholder,
        'wds-c-card--grouped': grouped,
        'wds-c-card--selected': this.state.selected
      });
      var ariaAttribute;
      if (ariaLabel) {
        ariaAttribute = {
          'aria-label': ariaLabel
        };
      } else if (hasTitleElement) {
        ariaAttribute = {
          'aria-labelledby': titleId
        };
      }
      var Tag = button ? 'button' : Element;
      return href || link ? /*#__PURE__*/React.createElement(Link, _extends({
        id: id,
        to: href,
        link: link,
        unStyled: true,
        className: cardClass,
        type: "default"
      }, ariaAttribute, otherProps), cardBody, cardFooter) : /*#__PURE__*/React.createElement(Tag, _extends({
        id: id,
        className: cardClass
      }, ariaAttribute, checkbox && {
        onClick: this.onClick
      }, otherProps), cardBody, cardFooter);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if (nextProps.radioSelected !== undefined) {
        return {
          selected: nextProps.radioSelected
        };
      }

      // no change to state
      return null;
    }
  }]);
  return Card;
}(React.Component);
Card.propTypes = propTypes;
Card.defaultProps = defaultProps;
export default Card;